// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"WrapperWithHoverableTooltip_tooltip__3xWF_"};